import { Form, Input } from "antd";
import ContentLayout from "../components/layout/ContentLayout";
import MyBreadcrumb from "../components/layout/MyBreadcrumb";
import Button from "../components/Button";
import { Link } from "react-router-dom";

export default function SettingsAccount() {
  return (
    <ContentLayout
      header={
        <>
          <h1>Your Account</h1>
          <MyBreadcrumb />
        </>
      }
    >
      <Form className="rewards-form" layout="vertical">
        <div className="rewards-form-section">
          <div className="rewards-inputs">
            <div className="form-row">
              <Form.Item name="streetNumber" label="First Name" required>
                <Input />
              </Form.Item>
              <Form.Item name="streetName" label="Last Name" required>
                <Input />
              </Form.Item>
            </div>
            <Form.Item name="address" label="Email Address" required>
              <Input />
            </Form.Item>
            <div>
              <Form.Item name="phone" label="Phone Number" required>
                <Input />
              </Form.Item>
              <Form.Item
                name="website"
                label="Website url for your business"
                required
              >
                <Input />
              </Form.Item>
              <Form.Item
                name="password"
                label={
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      width: "100%",
                    }}
                  >
                    Password
                    <Link
                      to="change-password"
                      style={{ textDecoration: "underline" }}
                    >
                      <h6>Change Password</h6>
                    </Link>
                  </div>
                }
              >
                <Input placeholder="**********************" disabled />
              </Form.Item>
            </div>
          </div>
        </div>

        <Form.Item className="rewards-form-btn">
          <Button>Save</Button>
        </Form.Item>
      </Form>
    </ContentLayout>
  );
}
